export default "__VITE_ASSET__BrUhL4cH__"